import { lazy } from 'react';

const routes = [
  {
    path: '/',
    exact: true,
    redirect: [
      {
        path: '/dashboard',
        roles: ['Supervisor'],
      },
      {
        path: '/chat',
        roles: ['Agent'],
      },
      {
        path: '/admin',
        roles: ['Admin'],
      },
    ],
  },
  {
    path: 'dashboard',
    component: lazy(() => import('./features/dashboard/Dashboard')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'digest-report',
    component: lazy(() =>
      import('./features/reporting/weekly-digest/WeeklyDigest')
    ),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'reporting',
    component: lazy(() => import('./features/reporting/Reporting')),
    exact: true,
    roles: ['Supervisor'],
  },
  // {
  //   path: 'team-activity',
  //   component: lazy(() => import('./features/team-activity/TeamActivity')),
  //   exact: true,
  //   roles: ['Supervisor'],
  // },
  {
    path: 'transcripts',
    component: lazy(() => import('./features/transcripts/Transcripts')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'transcripts/:sid/:id',
    component: lazy(() =>
      import('./features/transcripts/view-transcript/ViewTranscript')
    ),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'offline-messages',
    component: lazy(() =>
      import('./features/offline-messages/OfflineMessages')
    ),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'campaigns',
    component: lazy(() => import('./features/campaigns/Campaigns')),
    exact: true,
    roles: ['Supervisor'],
  },
  // {
  //   path: 'shortcuts',
  //   component: lazy(() => import('./features/settings/shortcuts/Shortcuts')),
  //   exact: true,
  //   roles: 'Supervisor',
  // },
  {
    path: 'unauthorized',
    component: lazy(() => import('./features/auth/unauthorized/UnAuthorized')),
    roles: ['Supervisor', 'Agent'],
  },
  {
    path: 'chat',
    component: lazy(() => import('./features/chat/Chat')),
    roles: ['Agent'],
  },
  {
    path: 'agent-dashboard',
    component: lazy(() => import('./features/agent-dashboard/AgentDashboard')),
    roles: ['Agent'],
  },
  {
    path: 'voc',
    component: lazy(() => import('./features/voc/Voc')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'voc/commentlist',
    component: lazy(() => import('./features/voc/comment-list/CommentList')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'commentlist',
    component: lazy(() => import('./features/voc/comment-list/CommentList')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'voc/dynamictopic',
    component: lazy(() => import('./features/voc/dynamic-topic/DynamicTopic')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'voc/treereport',
    component: lazy(() => import('./features/voc/tree-report/TreeReport')),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'preview-chat/:campaignId/:siteId',
    component: lazy(() =>
      import('./features/settings/chat-preview/ChatPreview')
    ),
    exact: true,
    roles: ['Supervisor'],
  },
  {
    path: 'admin',
    component: lazy(() => import('./features/admin/Admin')),
    roles: ['Admin'],
  },
  {
    path: 'users',
    component: lazy(() => import('./features/users/Users')),
    roles: ['Supervisor'],
  },
  //Hide For Prod
  // {
  //   path: 'payment',
  //   component: lazy(() => import('./features/payment/Payment')),
  //   roles: ['Supervisor'],
  // },
  {
    path: 'settings',
    component: lazy(() => import('./features/settings/Settings')),
    roles: ['Supervisor'],
  },
  {
    path: 'quick-setup',
    component: lazy(() => import('./features/quick-setup/QuickSetup')),
    roles: ['Supervisor'],
  },
];

export default routes;
